/**
 * Evaluates permission code against user permissions, supporting colon-delimited wildcards.
 * Example: "MENU-AND-ORDERS:*" or "MENU-AND-ORDERS:TASTING-BOOKINGS:*"
 */
export const hasPermission = (
  permission: string,
  rolePermissions: string[] = [],
): boolean => {
  if (rolePermissions.includes(permission)) {
    return true;
  }

  const [permBase] = permission.split(':');

  return rolePermissions.some(
    userPerm =>
      userPerm === `${permBase}:*` ||
      (userPerm.endsWith(':*') && permission.startsWith(userPerm.slice(0, -1))),
  );
};

export default hasPermission;
